import { createContext, useContext, useEffect, useState } from "react";
import { dict } from "@/lib/i18n";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem("flv_lang") || "fr";
    } catch {
      return "fr";
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem("flv_lang", lang);
      document.documentElement.lang = lang;
    } catch (_e) {
      /* noop */
    }
  }, [lang]);

  const t = dict[lang] || dict.fr;
  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used inside LangProvider");
  return ctx;
};
